import { URLS } from 'common/urls';
import buildV2Authorization from 'common/utils/buildV2Authorization';
import { UserSelector } from 'redux/selectors/UserSelector';
import {
    FETCH_V2_USER,
    FETCH_V2_USER_ME,
    FETCH_V2_USER_INDIVIDUAL,
    CREATE_V2_USER,
    UPDATE_V2_USER,
    DELETE_V2_USER
} from 'redux/actions/actionTypes';

export const create = (data) => (dispatch, getState) => {
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);

    return dispatch({
        type: CREATE_V2_USER,
        payload: {
            request: {
                url: URLS.API.USER.ROOT,
                method: 'POST',
                data,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const fetchAll = (pageUrl) => (dispatch, getState) => {
    const url = pageUrl ? pageUrl : URLS.API.USER.ROOT;
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);

    return dispatch({
        type: FETCH_V2_USER,
        payload: {
            request: {
                url,
                method: 'GET',
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const fetchIndividualUser = (id, options = {}) => (
    dispatch,
    getState
) => {
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);
    const url = `${URLS.API.USER.ROOT}${id}/`;

    return dispatch({
        type: FETCH_V2_USER_INDIVIDUAL,
        payload: {
            request: {
                url,
                method: 'GET',
                params: options,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const fetchMe = (options = {}) => (dispatch, getState) => {
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);
    const url = `${URLS.API.USER.ROOT}me/`;

    return dispatch({
        type: FETCH_V2_USER_ME,
        payload: {
            request: {
                url,
                method: 'GET',
                params: options,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const update = (data, id) => (dispatch, getState) => {
    const url = `${URLS.API.USER.ROOT}${id}/`;
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);
    return dispatch({
        type: UPDATE_V2_USER,
        payload: {
            request: {
                url,
                method: 'PATCH',
                data,
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};

export const deleteUser = (id) => (dispatch, getState) => {
    const url = `${URLS.API.USER.ROOT}${id}/`;
    const user = UserSelector(getState());
    const auth = buildV2Authorization(user);
    return dispatch({
        type: DELETE_V2_USER,
        payload: {
            request: {
                url,
                method: 'DELETE',
                headers: {
                    Authorization: auth
                }
            }
        }
    });
};
